import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';
import { isNull, isUndefined } from 'lodash';
import Link from 'next/link';

import Skeleton from 'Storybook/core/Skeleton/Skeleton';
import { formatCount } from 'Utilities/formatters';
import { applyCypressData } from 'Utilities/helpers';

import type { SidebarLinkProps } from './SidebarLink.types';

import styles from './SidebarLink.module.scss';

const SidebarLink: FC<SidebarLinkProps> = ({
	as,
	count,
	cypressId,
	href,
	isActive,
	isCountLoading,
	onClick,
	text,
	...props
}) => {
	const displayCount = !isCountLoading && !isNull(count) && !Number.isNaN(count) && !isUndefined(count) && count >= 0;

	return (
		<Link
			shallow
			as={as}
			className={cx(styles.sidebarLink, { [styles.isActive]: isActive })}
			data-thc-style-override="true"
			href={href}
			onClick={onClick}
			tabIndex={isActive ? -1 : undefined}
			{...props}
			{...applyCypressData(cypressId)}
		>
			<span className={styles.label}>{text}</span>
			{displayCount && <span className={styles.count}>{formatCount(count)}</span>}
			{isCountLoading && <Skeleton width={3} />}
		</Link>
	);
};

export default SidebarLink;
